import { loginCallbacks } from './form-callbacks/login';

import { initCaptchas } from './helpers/captchas';
import { initLogin } from './forms/login';

import { shiftSubdomain } from './helpers/extract-domain';

const initializers = [initCaptchas, initLogin];

const initialize = () => {
	initializers.forEach((initializer) => {
		try {
			initializer();
		} catch (e) {
			console.log(e);
		}
	});
};

initialize();

Object.assign(window, loginCallbacks);

window.shiftSubdomain = shiftSubdomain;
